const state = {
    module_name: undefined,
    enable: "true",
    dateRange: null,
    work_group_id: undefined,
    case_state_id: undefined,
    invoice_state_id: undefined,
    project_state_id: undefined
}

const getters = {
    /*getWorkGroup () {
        return state.work_group_id;
    }*/
}

// mutations
const mutations = {
    setModuleName: (state, module_name) => {
		  state.module_name = module_name
      localStorage.setItem("module_name", module_name);
    },
    setEnable: (state, enable) => {
		  state.enable = (enable)?("true"):("false");
      localStorage.setItem("enable", enable);
    },
    setDateRange: (state, dateRange) => {
		  state.dateRange = dateRange
      localStorage.setItem("dateRange", JSON.stringify(dateRange))
    },
    setWorkGroup: (state, work_group_id) => {
		  state.work_group_id = work_group_id
      localStorage.setItem("work_group_id", work_group_id);
    },
    setStateCase: (state, case_state_id) => {
		  state.case_state_id = case_state_id
      localStorage.setItem("case_state_id", case_state_id);
    },
    setStateInvoice: (state, invoice_state_id) => {
		  state.invoice_state_id = invoice_state_id
      localStorage.setItem("invoice_state_id", invoice_state_id);
    },
    setStateProject: (state, project_state_id) => {
		  state.project_state_id = project_state_id
      localStorage.setItem("project_state_id", project_state_id);
	},
};

// actions
const actions = {
    setModuleName: (context, module_name) => {
		  context.commit('setModuleName', module_name)
    },
    setEnable: (context, enable) => {
		  context.commit('setEnable', enable)
    },
    setDateRange: (context, dateRange) => {
		  context.commit('setDateRange', dateRange)
    },
    setWorkGroup: (context, work_group_id) => {
		  context.commit('setWorkGroup', work_group_id)
    },
    setStateCase: (context, case_state_id) => {
		  context.commit('setStateCase', case_state_id)
    },
    setStateInvoice: (context, invoice_state_id) => {
		  context.commit('setStateInvoice', invoice_state_id)
    },
    setStateProject: (context, project_state_id) => {
		  context.commit('setStateProject', project_state_id)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}